import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CommonService } from './common.service';
import { Observable } from 'rxjs';
import { APIResponse } from '../variables/api-response';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class StatesService {
  baseUrl: string;

  constructor(private http: HttpClient,
    private commonService: CommonService) {
    this.baseUrl = environment.API_URL;
  }


  getStates() {
    return this.http.get<APIResponse>(this.baseUrl + 'api/forms/states');
  }

  getAllStates() {
    return this.http.get<APIResponse>(this.baseUrl + 'api/forms/customer-required-to-submit-states');
  }

  getAllStateAddress() {
    return this.http.get<APIResponse>(this.baseUrl + 'api/forms/customer-required-to-submit-states');
  }

  getAllStatesData() {
    return this.http.get<APIResponse>(this.baseUrl + 'api/forms/states');
  }

  getCountries() {
    return this.http.get<any>(this.baseUrl + 'api/forms/country');
  }

  getStatesByCountry(countryId: number) {
    return this.http.get<APIResponse>(this.baseUrl + 'api/forms/states/' + countryId);
  }

  getAllFormsByState(state) {
    return this.http.get<APIResponse>(this.baseUrl + 'api/forms/state/' + state);
  }

  getFormById(id: number) {
    return this.http.get<APIResponse>(this.baseUrl + 'api/forms/' + id);
  }
}

